import { validatePasswordStrength } from 'anchor-password-policy';
export function validatePassword(password, userInputs) {
    return validatePasswordStrength(password, userInputs) || 'Password is not strong enough';
}
